<template>
    <v-card min-width="21vw" max-width="30vw" align="center" justify="center" light outlined>
        <v-card-title style="background-color: #d2d7e1">
            <v-list-item>
                <v-list-item-title class="d-flex"><v-icon class="mr-3" small>fa-lock</v-icon><h2>Pago seguro via ePayco</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon class="icon" @click="cancelPayment" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-7 py-7">
            <v-overlay :absolute="true" :value="overlayProcessingPayment"><v-progress-circular :size="70" width="5" indeterminate/></v-overlay>
            <p>
                Te estas suscribiendo al plan <b>{{ plan.planName }}</b>.<br>
                a <b>{{ (plan.billed.endsWith('yearly'))? (plan.price * 12).toFixed(1) : plan.price }}</b> {{ plan.currency }} {{ plan.billed }}.
            </p>
            <v-form v-model="valid">
                <v-container fluid>
                    <v-row class="align-center">
                        <h4 class="mr-5">Tus datos personales</h4>
                        <v-divider/>
                    </v-row>
                    <v-row class="mb-n5">
                        <v-col cols="12">
                          <v-text-field label="Nombre Completo Tarjetahabiente" v-model="personName" :rules="personaNameRules" outlined dense/>
                        </v-col>
                    </v-row>
                    <v-row class="mb-n5">
                        <v-col cols="5">
                            <v-select label="Id" item-text="name" item-value="id" :items="idTypes" hint="Tipo de id" v-model="idType" :rules="idTypeRules" outlined dense/>
                        </v-col>
                        <v-col cols="7">
                            <v-text-field label="Id Número" hint="Número de identificación" v-model="idNumber" :rules="docNumberRules" outlined dense/>
                        </v-col>
                    </v-row>
                    <v-row class="align-center mt-3">
                        <h4 class="mr-5">Tus datos de pago</h4>
                        <v-divider/>
                    </v-row>
                    <v-row class="mb-n5">
                        <v-col cols="10">
                            <v-text-field label="Número de tarjeta" hint="Tu número de tarjeta de credito" type="number" v-model="ccNumber" :rules="numberRules" outlined dense/>
                        </v-col>
                        <v-col cols="2">
                            <v-img max-height="49" max-width="49" :src="`https://swiset.com/wp-content/uploads/2020/05/${ccIcon}.svg`"/>
                        </v-col>
                    </v-row>
                    <v-row class="mb-n5">
                        <v-col cols="4">
                            <v-select :items="years" label="Año de vencimiento" hint="Año de vencimiento"
                                          v-model="ccExpDateYear" :rules="expYearRules" outlined dense/>
                        </v-col>
                        <v-col cols="4">
                            <v-select :items="months" label="Mes de vencimiento" hint="Mes de vencimiento"
                                          v-model="ccExpDateMonth" :rules="expMonthRules" outlined dense/>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field label="CVC" hint="Codigo de seguridad" v-model="ccCVC" :rules="cvcRules" outlined dense/>
                        </v-col>
                    </v-row>
                    <div class="d-flex align-center text-start">
                        <v-checkbox v-model="agree" :rules="agreeRules"/>
                        <p><br>Acepto los <a href="https://swiset.com/terms-and-conditions/" target="_blank">terminos y condiciones</a></p>
                    </div>
                    <v-btn :disabled="!valid" class="my-2" @click="proceedToPayment">Proceder al pago »</v-btn>
                </v-container>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
    // eslint-disable-next-line no-unused-vars
    import Repository from '../../repositories/subscription';
    export default {
        name: "Checkout",
        props: {
            plan: Object,
            clubId: Number,
        },
        data() {
            return {
                overlayProcessingPayment: false,
                mask: '####-####-####-####',
                ccIcon: 'cc',
                idTypes: [
                    {
                        id: 'CC',
                        name: 'Cédula de Ciudadanía',
                    },
                    {
                        id: 'SSN',
                        name: 'Número de Seguridad Social',
                    },
                    {
                        id: 'LIC',
                        name: 'Licencia de conducción',
                    },
                    {
                        id: 'PPN',
                        name: 'Pasaporte',
                    },
                ],
                years: [
                    '2020',
                    '2021',
                    '2022',
                    '2023',
                    '2024',
                    '2025',
                    '2026',
                    '2027',
                    '2028',
                    '2029',
                    '2030',
                ],
                months: [
                    '01',
                    '02',
                    '03',
                    '04',
                    '05',
                    '06',
                    '07',
                    '08',
                    '09',
                    '10',
                    '11',
                    '12',
                ],

                // Data
                personName: '',
                idType: '',
                idNumber: '',
                ccNumber: '',
                ccExpDateMonth: '',
                ccExpDateYear: '',
                ccCVC: '',
                agree: false,

                // Rules
                valid: false,
                personaNameRules: [
                    n => !!n || 'Nombre completo es obligatorio',
                ],
                idTypeRules: [
                    t => !!t || 'Tipo es obligatorio',
                ],
                docNumberRules: [
                    n => !!n || 'La identificación es obligatoria'
                ],
                numberRules: [
                    n => !!n || 'El número de la tarjeta es obligatoria',
                    n => n >= 0 || 'Número invalido',
                    n => n.length <= 16 || 'Número invalido',
                ],
                expYearRules: [
                    e => !!e || 'Obligatorio',
                    e => e.length === 4 || 'Invalido',
                ],
                expMonthRules: [
                    e => !!e || 'Obligatorio',
                    e => e.length === 2 || 'Invalido',
                ],
                cvcRules: [
                    c => !!c || 'Obligatorio',
                    c => (c.length > 2 && c.length < 5) || 'Invalido',
                ],
                agreeRules: [
                    a => a === true || 'Debes aceptar',
                ],
            };
        },
        mounted() {
            this.personName = `${this.$store.state.user.firstName} ${this.$store.state.user.lastName}`
            this.idType = this.idTypes[0].id;
            this.ccExpDateYear = this.years[0];
            this.ccExpDateMonth = this.months[0];
        },
        watch: {
            ccNumber() {
                this.renderCCIcon();
            },
        },
        methods: {
            renderCCIcon() {
                if (this.ccNumber.startsWith('4'))
                    this.ccIcon = 'visa';
                else if (this.ccNumber.startsWith('5') || this.ccNumber.startsWith('2') )
                    this.ccIcon = 'mastercard';
                else if (this.ccNumber.startsWith('34') || this.ccNumber.startsWith('37'))
                    this.ccIcon = 'amex';
                else if (this.ccNumber.startsWith('6'))
                    this.ccIcon = 'discover';
                else
                    this.ccIcon = 'cc';
            },
            proceedToPayment() {
                if(this.valid) {
                    this.overlayProcessingPayment = true;
                    let userId = this.$store.state.user.id;
                    let card = {
                        user_full_name: this.personName,
                        user_id: userId,
                        card_number: this.ccNumber + "",
                        card_exp_year: this.ccExpDateYear,
                        card_exp_month: this.ccExpDateMonth,
                        card_cvc: this.ccCVC,
                        doc_type: this.idType,
                        doc_number: this.idNumber,
                        club_id: this.clubId
                    };

                    Repository.tokenizeCard(card).then((response) => {
                        if(response.status < 400) {
                            let realPlanId  =  (this.clubId !== undefined)? this.plan.ePaycoPlanId :
                                `${this.plan.planName.trim().replaceAll(' ', '_')}_${(new Date()).getFullYear()}`;

                            Repository.chargeSubscription(userId, realPlanId, this.clubId).then((chargeResponse) => {
                                if(chargeResponse.status === 200)
                                    this.$emit('successfulPayment');
                                else
                                    this.$emit('errorOnPayment');
                            });
                        }
                        else
                            this.$emit('errorOnPayment');
                    }).catch((error) => {
                        // eslint-disable-next-line no-console
                        console.log(error.response.data);
                        this.$emit('errorOnPayment')
                    });
                }
                else
                    alert('Uno o mas campos tienen problemas');
            },
            cancelPayment() {
                this.$emit('cancelPayment');
            },
        }
    }
</script>

<style scoped>
    .v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
    .v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
    {
        -webkit-appearance: none !important;
        margin: 0;
    }
</style>
